import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from './selectStyles';

export default function SelectSize({ callback, value, width ,name="size", usersFilter, placeholder }) {

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '100px', border: 1 })
        : makeDarkSelectStyles({ width: width || '100px' });


    const sizes = [10,20,30,50,70,100,200];

    
    var options = []
    Array.from(sizes, (e, i) => {
        var option = null;
        option = {
            label: sizes[i],
            value: sizes[i]
        }
        options.push(option)
    })

    var option = {
        label: "All",
        value: 100000
    }
    options.push(option)

    const handleSelect = (e) => {
        value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Size"}
                    value={options && options.filter(obj => obj.value == value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>

        </>
    )
}
